<template>
  <div class="table-container">
    <MDBTable hover>
      <thead>
        <tr>
          <th v-for="(item, i) in tableHeader" :key="i" scope="col">
            {{ item.header }}
          </th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody v-if="isLoading" class="table-body">
        <tr>
          <td colspan="7">
            <div class="loading-container" id="table-loader">
              <MDBLoading parentSelector=".table-body" loadingText="" backdropColor="white" :backdropOpacity="0" />
            </div>
          </td>
        </tr>
      </tbody>
      <tbody v-else-if="projects.length < 1">
        <tr>
          <td colspan="7">
            <div class="table-empty-container">
              <img src="@/assets/images/2024/empty-table.png" alt="empty-table" />
              <div>
                <h4>There are no projects made on your end.</h4>
                Start creating Projects by clicking the “Create a Project” button!
              </div>
            </div>
          </td>
        </tr>
      </tbody>
      <tbody v-else-if="projects.length > 0">
        <tr v-for="(project, key) in projects" :key="key" @click="openProjectSummary(project)">
          <ProjectTaggingMainTableRow :project="project" />
        </tr>
      </tbody>
    </MDBTable>
    <SPAPagination class="pagination" textPerPage="Items per page" :pagination="projectsPagination" @changePage="changePage" />
  </div>
</template>

<script>
import { MDBTable, MDBLoading } from 'mdb-vue-ui-kit';
import { storeToRefs } from 'pinia';
import { parseDate } from '../../../../helpers/dateParser';
import ProjectTaggingMainTableRow from './ProjectTaggingMainTableRow.vue';
import { ref } from 'vue';
import { checkBlankSpace } from '../../../../helpers/inputValidator';
import { useDebounceFn } from '@vueuse/core';
import SPAPagination from '../../../../components/SPAPagination.vue';
import { useProjectTaggingStore } from '../../../../stores/projectTagging';
export default {
  components: {
    MDBTable,
    MDBLoading,
    ProjectTaggingMainTableRow,
    SPAPagination,
  },
  setup() {
    const projectTagging = useProjectTaggingStore();
    const {
      projects,
      projectsPagination,
      isLoading,
      createModalState,
      projectCode,
      projectName,
      projectStatus,
      searchFilter,
      searchString,
      viewProject,
      selectedProject,
      drawerState,
      selectedStatusFilter,
    } = storeToRefs(projectTagging);
    const tableHeader = [
      {
        header: 'PROJECT CODE',
      },
      {
        header: 'PROJECT NAME',
      },
      {
        header: 'PROJECT OWNER',
      },
      {
        header: '# OF ASSIGNEES',
      },
      {
        header: 'DATE CREATED',
      },
      {
        header: 'UPDATED BY',
      },
    ];
    const changePage = async (paginate) => {
      const params = ref({
        PageNumber: paginate.currentPage,
        RowsPerPage: paginate.itemsPerPage,
        StatusIds: selectedStatusFilter.value,
      });
      if (!checkBlankSpace(searchString.value)) {
        params.value = {
          ...params.value,
          ...{
            FilterBy: searchFilter.value,
            SearchString: searchString.value,
          },
        };
      }
      await projectTagging.getProjects(params.value);
    };
    const openProjectSummary = (project) => {
      selectedProject.value = project;
      if (drawerState.value) {
        drawerState.value = false;
        debouncedDrawer();
      } else {
        viewProject.value = true;
      }
    };
    const debouncedDrawer = useDebounceFn(() => {
      viewProject.value = true;
    }, 1000);
    return {
      tableHeader,
      projects,
      projectsPagination,
      changePage,
      parseDate,
      isLoading,
      createModalState,
      projectCode,
      projectName,
      projectStatus,
      openProjectSummary,
    };
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/sass/announcement-module.scss' as *;
.pagination {
  border-top: 1px solid $neutral-20;
}
.table-empty-container,
.loading-container {
  min-height: 595px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
:deep(.loading-spinner) {
  z-index: unset;
  color: #879a94;
  & .spinner-border {
    width: 120px;
    height: 120px;
    border-width: 10px;
  }
}
</style>
